import SectionTitle from "@/components/SectionTitle/SectionTitle.vue";
import html2pdf from "html2pdf.js";
import Utils from "@/mixins/Utils";
import { mapState } from "vuex";

import profileCandidateService from "@/services/profileCandidate";

export default {
  components: {
    SectionTitle,
  },
  data() {
    return {
      experiences: [],
      trainings: [],
      transportModes: {},
      resume: {
        width: 200,
        height: 200,
      },
      isExportingAsPDF: false,
    };
  },
  mixins: [Utils],
  computed: {
    ...mapState(["user"]),
  },
  created() {
    this.loadExperiences();
    this.loadTrainings();
    this.loadTransportMode();
  },
  methods: {
    loadExperiences() {
      const vue = this;
      profileCandidateService
        .getExperiences()
        .then(function(response) {
          // handle success
          if (response.success === true) {
            vue.experiences = response.experiencesList;
          } else {
            console.error(
              "/profil-candidat/get-experiences-adv : failed with false success"
            );
          }
        })
        .catch(function(error) {
          vue.callToaster(vue.$t('problem-arise'));
        });
    },
    loadTrainings() {
      const vue = this;

      profileCandidateService
        .getTraining()
        .then(function(response) {
          // handle success
          if (response.success === true) {
            vue.trainings = response.trainings;
          } else {
            console.error(
              "/profil-candidat/get-trainings-adv : failed with a false success value"
            );
          }
        })
        .catch(function(error) {
          vue.callToaster(vue.$t('problem-arise'));
        });
    },
    loadTransportMode() {
      const vue = this;
      profileCandidateService.getTransportMode()
        .then(function(response) {
          // handle success
          if (response.success === true) {
            vue.transportModes = response.transportModes;
          } else {
            console.error(
              "/profil-candidat/get-trainings-adv : failed with a false success value"
            );
          }
        })
        .catch(function(error) {
          vue.callToaster(vue.$t('problem-arise'));
        })
    },
    exportResumeAsPDF() {
      const vue = this;

      vue.isExportingAsPDF = true;

      var opt = {
        margin: 0.25,
        filename: "CV.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };

      html2pdf()
        .from(vue.$refs.resume)
        .set(opt)
        .save();

      vue.isExportingAsPDF = false;
    },
  },
};
